import { DatePipe } from "@angular/common";
import { PipeTransform, Pipe, OnInit } from "@angular/core";
import { AppConsts } from "@shared/AppConsts";

@Pipe({
    name: 'userdate'
})

export class UserDateCustomPipe extends DatePipe implements PipeTransform {


    transform(value: any, args: any, locale: string = undefined): any {
        if (locale === undefined || locale === '') {
            // locale = abp.localization.currentLanguage.name;
            locale = 'vi';        
        }
        if (value === null || value === undefined) {
            return null;
        }

        let formatDate = AppConsts.FormatDate.ShortDate[0].display;
        let userTimeZone: string;
        let userOffset = abp.timing.timeZoneInfo.windows.currentUtcOffsetInMilliseconds / (3600000);
        if (userOffset >= 0) {
            userTimeZone = '+' + userOffset.toString();
        }
        else {
            userTimeZone = userOffset.toString();
        }

        if (args === 'short') {
            formatDate = AppConsts.FormatDate.ShortDate.find(s => s.locale == locale).display;
        }
        else {
            formatDate = AppConsts.FormatDate.LongDate.find(s => s.locale == locale).display;
        }

        return super.transform(value, formatDate, userTimeZone);
    }
}